var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"login-menu"},[(_vm.activeName === 'user')?_c('user-login'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }